
<div class="screen-booking">
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div style="text-align:center">{{ getAllInfos.restoName }}</div>
      <div style="font-weight:100; font-size:14px">
        <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="success-container" v-loading="loading">
      <el-row :class="'black-inputs'">
        <el-col :span="18" :offset="3">
          Le moyen de paiement n'as pas fonctionné<br>
          <br>
          La réservation n'as pas été prise en compte<br>
          <br>
          Vous allez être redirigé automatiquement vers l'application
          <br>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
